export enum DragItemTypes {
    CARD = 'card',
    CARD_ROOT = 'card_root',
    CARD_CHILD = 'card_child'
}

export enum BaseItemTypes {
  SELECTION = 0,
  PROJECTION = 1,
  GRAPH = 2,
  PIE_CHART = 3,
  BAR_CHART = 4,
  SELECTED_COLUMN = 5,
  LIST = 6,
  FOLDER = 7,

  // superficial indices
  REPORT = 900,
  BREAK = 901
}